export default [
  '#FFB600',
  '#64DCBF',
  '#F77389',
  '#B57ACE',
  '#5273E0',
  '#E87040',
  '#8BBB11',
];
